// Lightning bolt animation helpers

export const LIGHTNING = {
  DEFAULT_COLOR:   'rgba(255, 240, 80, 1)',
  START_Y:         -20,
  ROUGHNESS_RATIO: 0.8,
  MIN_LEN_RATIO:   0.15,
  DECAY_FACTOR:    0.55,
  PASS2_DELAY:     80,
  PASS3_DELAY:     160,
  CLEANUP_DELAY:   280,
  STROKE_WIDTHS:   [8, 3, 1.5],
  STROKE_ALPHAS:   [0.25, 0.7, 0.9],
}

// Midpoint displacement algorithm — recursively subdivides the path between
// (x1,y1) and (x2,y2), adding random perpendicular jitter at each midpoint
// until all segments are shorter than minLen.
export function buildBoltPoints(x1, y1, x2, y2, roughness, minLen) {
  let points = [{ x: x1, y: y1 }, { x: x2, y: y2 }]
  let r = roughness
  while (true) {
    const newPoints = [points[0]]
    let subdivided = false
    for (let i = 0; i < points.length - 1; i++) {
      const a = points[i], b = points[i + 1]
      const dx = b.x - a.x, dy = b.y - a.y
      if (dx * dx + dy * dy > minLen * minLen) {
        newPoints.push({
          x: (a.x + b.x) / 2 + (Math.random() - 0.5) * 2 * r,
          y: (a.y + b.y) / 2 + (Math.random() - 0.5) * 2 * r
        })
        subdivided = true
      }
      newPoints.push(b)
    }
    points = newPoints
    r *= LIGHTNING.DECAY_FACTOR
    if (!subdivided) break
  }
  return points
}

// Renders the bolt with three overlapping passes: wide glow, mid stroke, bright core.
export function drawBoltOnCtx(ctx, points, color, opacity) {
  const drawLine = (lineWidth, strokeStyle, alpha) => {
    ctx.save()
    ctx.globalAlpha = opacity * alpha
    ctx.lineWidth = lineWidth
    ctx.strokeStyle = strokeStyle
    ctx.lineCap = 'round'
    ctx.lineJoin = 'round'
    ctx.beginPath()
    ctx.moveTo(points[0].x, points[0].y)
    for (let i = 1; i < points.length; i++) ctx.lineTo(points[i].x, points[i].y)
    ctx.stroke()
    ctx.restore()
  }
  drawLine(LIGHTNING.STROKE_WIDTHS[0], color,     LIGHTNING.STROKE_ALPHAS[0])
  drawLine(LIGHTNING.STROKE_WIDTHS[1], color,     LIGHTNING.STROKE_ALPHAS[1])
  drawLine(LIGHTNING.STROKE_WIDTHS[2], '#ffffff', LIGHTNING.STROKE_ALPHAS[2])
}
